export default __webpack_public_path__ + "c8d26115beb9193d3cf8ed98b2317210.svg";